module.exports = __webpack_public_path__ + "img/companyIntro16.f94eb20f.png";